document.addEventListener("DOMContentLoaded", () => {
  const hideEmpty = () => {
    document.querySelectorAll(".jdgm-rev__body p").forEach(p => {
      if (p.textContent.trim() === "This review has no text.") {
        p.style.display = "none";
      }
    });
  };

  hideEmpty();

  const container = document.getElementById("judgeme_product_reviews");
  if (container) {
    new MutationObserver(hideEmpty).observe(container, {
      childList: true,
      subtree: true
    });
  }
});